// src/services/EmpresaService.js
import fetch from 'auth/FetchInterceptor';

const EmpresaService = {};

// Sin params (o con solo_activas) -> selector simple {id, nombre}, usado por Empleados.
// Con { paginate: 1, ... } -> listado paginado con filtros, usado por la pantalla de Empresas.
EmpresaService.getAll = function (params = {}) {
    return fetch({
        url: '/v1/empresas',
        method: 'get',
        params,
    });
};

EmpresaService.getById = function (id) {
    return fetch({
        url: `/v1/empresas/${id}`,
        method: 'get',
    });
};

EmpresaService.create = function (data) {
    return fetch({
        url: '/v1/empresas',
        method: 'post',
        data,
    });
};

EmpresaService.update = function (id, data) {
    return fetch({
        url: `/v1/empresas/${id}`,
        method: 'put',
        data,
    });
};

EmpresaService.remove = function (id) {
    return fetch({
        url: `/v1/empresas/${id}`,
        method: 'delete',
    });
};

EmpresaService.updateEstado = function (id, activa) {
    return fetch({
        url: `/v1/empresas/${id}/estado`,
        method: 'patch',
        data: { activa },
    });
};

EmpresaService.getResumen = function (id) {
    return fetch({
        url: `/v1/empresas/${id}/resumen`,
        method: 'get',
    });
};

EmpresaService.getEmpleados = function (id, params = {}) {
    return fetch({
        url: `/v1/empresas/${id}/empleados`,
        method: 'get',
        params,
    });
};

EmpresaService.uploadLogo = function (id, file) {
    const formData = new FormData();
    formData.append('logo', file);

    return fetch({
        url: `/v1/empresas/${id}/logo`,
        method: 'post',
        data: formData,
    });
};

export default EmpresaService;